import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useProfile } from '../shared/hooks/AuthContext';

import useConfigurationStep, {
  ConfigurationStep
} from '../api/hooks/useConfigurationStep';
import { RoutePaths } from './AppRoutes';
import { isBearerTokenAuthEnabled } from '../shared/hooks/auth';

export function GuardedRoute() {
  const navigate = useNavigate();
  const { configurationStep, isLoading: isConfigurationStepLoading } =
    useConfigurationStep();
  const { pathname } = useLocation();

  const {
    profile,
    isTenantAdmin,
    isLoading: isProfileLoading,
    login,
    isAuthenticated
  } = useProfile();
  const isAdministrator = profile ? isTenantAdmin(profile) : false;

  useEffect(() => {
    if (isProfileLoading || isConfigurationStepLoading) {
      return;
    }

    const shouldRedirectToConfigurationAssistant =
      isAdministrator &&
      configurationStep?.configurationStep !== ConfigurationStep.FINISH &&
      pathname !== RoutePaths.CONFIGASSISTANT;

    const shouldRedirectToAntraege =
      pathname === RoutePaths.CONFIGASSISTANT &&
      (!isAdministrator ||
        configurationStep?.configurationStep === ConfigurationStep.FINISH);

    if (shouldRedirectToConfigurationAssistant) {
      navigate(RoutePaths.CONFIGASSISTANT, { replace: true });
    } else if (shouldRedirectToAntraege) {
      navigate(RoutePaths.ANTRAEGE, { replace: true });
    }
  }, [
    configurationStep,
    isAdministrator,
    isConfigurationStepLoading,
    isProfileLoading,
    navigate,
    pathname
  ]);

  useEffect(() => {
    if (!isAuthenticated && isBearerTokenAuthEnabled() && login) {
      login();
    }
  }, [isAuthenticated, login]);

  return profile ? <Outlet /> : null;
}

export default GuardedRoute;
